import React, { createContext, useContext } from 'react'
import { useAdminLiveFeed } from '../hooks/useAdminLiveFeed'
import { LiveConversation } from '../components/AdminPanel/Lori Manager/liveTypes'

interface AdminLiveFeedContextValue {
    liveCount: number
    conversations: LiveConversation[]
    isConnected: boolean
    hasInitialState: boolean
}

const AdminLiveFeedContext = createContext<AdminLiveFeedContextValue>({
    liveCount: 0,
    conversations: [],
    isConnected: false,
    hasInitialState: false,
})

export const AdminLiveFeedProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const value = useAdminLiveFeed()
    return (
        <AdminLiveFeedContext.Provider value={value}>
            {children}
        </AdminLiveFeedContext.Provider>
    )
}

export const useAdminLiveFeedContext = (): AdminLiveFeedContextValue => {
    return useContext(AdminLiveFeedContext)
}
